import React from "react";

const SvgRightArrow = props => <svg width={21} height={16} viewBox="0 0 21 16" {...props}><g fill="#FFF" fillRule="evenodd"><path d="M13.414.05l7.625 7.98L18.05 8 12 1.464 13.414.05z" /><path d="M21.044 8.006l-7.63 7.91L12 14.503l6.127-6.514 2.917.018z" /><path d="M0 7h20v2H0z" /></g></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/right-arrow_41f82b.svg";
export { SvgRightArrow as ReactComponent };